module.exports = __webpack_public_path__ + "static/img/logo31.94f3e9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo31.jpg
// module id = 0UO4
// module chunks = 1